import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Stepper, Step, StepLabel, StepConnector, Typography, Button } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Check from '@material-ui/icons/Check';
import DoneIcon from '@material-ui/icons/Done';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import CloseIcon from '@material-ui/icons/Close';

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed, fail } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : null}
      {fail ? <div className={classes.circle} /> : null}
      {active ? <div className={classes.circle} /> : null}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step failed.
   */
  fail: PropTypes.bool,
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
  alternativeLabel: {
    // top: 22,
  },
  active: {
    '& $line': {
      backgroundColor:
        'rgb(87,173,138)'
    },
  },
  completed: {
    '& $line': {
      backgroundColor:
        'rgb(87,173,138)',
    },
  },
  line: {
    marginTop: '5px',
    height: 13,
    border: 0,
    backgroundColor: 'rgb(234, 241, 252)',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#fff',
    zIndex: 1,
    color: 'rgb(234, 241, 252)',
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid',
    borderColor: 'rgb(234, 241, 252)'
  },
  active: {
    borderColor: 'rgb(87,173,138)',
    backgroundColor: '#fff',
    color: 'rgb(87,173,138)'
  },
  completed: {
    borderColor: '#fff',
    backgroundColor: 'rgb(87,173,138)',
    color: '#fff',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  fail: {
    borderColor: 'rgb(197, 96, 82)',
    backgroundColor: '#fff',
    color: 'rgb(197, 96, 82)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  }
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed, fail } = props;

  console.log('ColorlibStepIcon', active, completed, fail)

  const icons = {
    1: <WhatsAppIcon />,
    2: <DoneIcon />,
    3: <DoneIcon />,
    4: <DoneIcon />,
    5: <DoneIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.fail]: fail,
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {fail ? <CloseIcon /> : icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return [
    'Connect WhatsApp Business Account',
    'Updating your Account',
    'Assigning your Phone Number',
    'Preparing WhatsApp Sender',
    'Creating your WhatsApp Templates',
  ];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return 'You must first connect your WhatsApp account to authorize sending messages on your behalf.';
    case 1:
      return 'We\'re configuring your account to support WhatsApp messaging';
    case 2:
      return 'We\'re assigning your phone number for WhatsApp messaging';
    case 3:
      return 'We\'re preparing your WhatsApp sender';
    case 4:
      return 'We\'re creating your WhatsApp templates';
    case 5:
      return 'You\'re all set to use WhatsApp messaging!';
    default:
      return 'Unknown step';
  }
}

export const WhatsAppStatus = ({ status }) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [failedStep, setFailedStep] = React.useState(null);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  useEffect(() => {
    const _steps = ['connectWaba', 'subAccount', 'phoneAssignment', 'whatsAppSender', 'whatsAppTemplates']

    console.log('useEffect', status, _steps)
    let currentStep = 0
    let failStep = null

    if (status.done) {
      setActiveStep(5)
      setFailedStep(null)
      return
    }

    for (const index in _steps) {
      const key = _steps[index]
      console.log('index & key', index, key, status[key])
      
      // if step is success, then its completed
      if (status[key] === 'SUCCESS') {
        console.log('setActiveStep', index, key)
        currentStep = Math.max(currentStep, index)
        continue
      }

      // this is the step that is currently in progress, set the activeStep and break the loop
      if (status[key] === 'INPROGRESS') {
        console.log('setActiveStep', index, key)
        currentStep = Math.max(currentStep, index)
        break
      }

      // if step failed, set the failedStep and break the loop
      if (status[key] === 'FAIL') {
        currentStep = Math.max(currentStep, index)
        failStep = Math.max(failStep, index)
        break
      }
    }

    console.log('setActiveStep', currentStep)
    console.log('setFailedStep', failStep)
    
    setActiveStep(currentStep)
    setFailedStep(failStep)
  }, [status])

  return (
    <div className={classes.root}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
        {steps.map((label, index) => {
          console.log('Stepper', label, index, failedStep, index === failedStep)
          return (
            <Step key={label}>
              <StepLabel StepIconComponent={(props) => <ColorlibStepIcon {...props} fail={index === failedStep} />}>
                <strong>{label}</strong>
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', margin: '2rem' }}>
        <div>
          <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
        </div>
        {failedStep ? (
          <>
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              Something went wrong, click try again, if the issue persists contact an administrator.
            </Alert>
          </>
        ) : null}
      </div>
    </div>
  );
}